import { ModuleField, Registry, Options, defaultOptions } from './base'
import { Apply } from '../../../cast'

const kind = 'String'

interface StringOptions extends Options {
  multiLine: boolean;
  useRichTextEditor: boolean;
  useCodeEditor: boolean;
  codeLanguage: string;
  multiDelimiter: string;
  sanitizeXSS: boolean;
}

const defaults = (): Readonly<StringOptions> => Object.freeze({
  ...defaultOptions(),
  multiLine: false,
  useRichTextEditor: false,
  useCodeEditor: false,
  codeLanguage: 'yaml',
  multiDelimiter: '\n',
  sanitizeXSS: true,
})

export class ModuleFieldString extends ModuleField {
  readonly kind = kind

  options: StringOptions = { ...defaults() }

  constructor (i?: Partial<ModuleFieldString>) {
    super(i)

    this.applyOptions(i?.options)
  }

  applyOptions (o?: Partial<StringOptions>): void {
    if (!o) return
    super.applyOptions(o)

    Apply(this.options, o, String, 'multiDelimiter', 'codeLanguage')
    Apply(this.options, o, Boolean, 'multiLine', 'useRichTextEditor', 'useCodeEditor', 'sanitizeXSS')
  }
}

Registry.set(kind, ModuleFieldString)
